import type { PropsWithChildren } from 'react';

export function AuthenticatedRouteTransition({
  children,
}: PropsWithChildren) {
  return <>{children}</>;
}
